module.exports = __webpack_public_path__ + "img/step2.82442c9b.png";